import React from "react";
import { Step2PhoneRegisFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const Step2PhoneRegisForm = ({ onSubmit }) => {
  const { t } = useTranslation(["common"]);
  const schema = yup.object().shape({
    test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Step2PhoneRegisFormStyled>
      <div className="register_header">{t("Verify OTP code", { ns: "common" })}</div>
      <div className="register_title">{t("Reference code", { ns: "common" })}</div>
      <div className="reference_code">KmL2e</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              theme_standard2
              className="otp_code"
              label={t("Enter OTP code", { ns: "common" })}
              placeholder="เว้นไว้ใช้ lib แทน"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
      </form>
      <div className="resend_otp_button">
        <button className="resend_otp">{t("Request new OTP", { ns: "common" })}</button>
      </div>
      <div className="register_button">
        <Buttons.BgStandard label={t("Confirm", { ns: "common" })} />
      </div>
    </Step2PhoneRegisFormStyled>
  );
};

Step2PhoneRegisForm.propTypes = {};

export default Step2PhoneRegisForm;
